import 'sumoselect/jquery.sumoselect.min'
